import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import { withOptimizely } from '@ynap/optimizely-utils';
import { SizeSelect, CTAButtons } from '@ynap/product-details-page';

const bem = new BEMHelper('RecommendationsOptionsOverlay');

const RecommendationsOptionsOverlay = (props) => {
    const {
        product,
        messages,
        loading,
        optimizely,
        wrapperRef,
        selectedProductVariantWithBuyableStatus,
        selectedSize,
        setSelectedSize,
        noSizeNotification,
        setNoSizeNotification,
        CTAButtonsState,
    } = props;

    const { href = '', selectedProductVariant } = product;
    const { sKUs } = selectedProductVariant;
    const { addToCart, addToCartLoading = false, wishlists, wishlistId, addToWishlist, addToWishlistLoading = false, errors } = CTAButtonsState;

    const displayableSKUs = sKUs?.filter((sku) => sku.displayable);

    const onChangeSelectedSize = (sizeSku, sizeLabel) => {
        setSelectedSize({ sizeSku, sizeLabel });
        setNoSizeNotification('');
    };

    const trackedAddToWishlist = (sku, wishlistId) => {
        return addToWishlist(sku, wishlistId).then(() => {
            /* istanbul ignore next */
            return optimizely?.track('wl_recommendationsaddtowl');
        });
    };

    const trackedAddToBag = (sku) => {
        return addToCart(sku, { includeShoppingCart: false, setActionNotificationOnError: false }).then(() => {
            /* istanbul ignore next */
            return optimizely?.track('wl_recommendationsaddtobag');
        });
    };

    return (
        <div className={bem('recommendationsOptions')} ref={wrapperRef}>
            <div className={bem('mask')}></div>
            <SizeSelect
                className={bem('sizeSelect', { loading })}
                skus={displayableSKUs}
                value={selectedSize?.sizeLabel}
                messages={messages}
                changeSelectedSku={(sizeSku, sizeLabel) => onChangeSelectedSize(sizeSku, sizeLabel)}
                loading={loading}
                noSizeNotification={noSizeNotification}
                displayLabel={false}
                numberOfDisplaySize={4}
                sizeGridFeatureToggle={false}
                disabledControls={false}
                /* istanbul ignore next */
                onClick={() => optimizely.track('wl_recommendationsselectsize')}
            />
            <CTAButtons
                className={bem('ctaButtons', { loading })}
                modifier={'modifier'}
                messages={messages}
                cart={{
                    addToCartLoading,
                    addToCart: trackedAddToBag,
                    failedAddToBag: () => {},
                }}
                wishlist={{
                    addToWishlistLoading,
                    addToWishlist: trackedAddToWishlist,
                    wishlists,
                    wishlistId,
                    failedAddToWishlist: () => {},
                }}
                skuPartNumber={selectedSize?.sizeSku?.partNumber}
                selectedProductVariant={selectedProductVariantWithBuyableStatus}
                multipleWishlistsFeatureToggle={true}
                errors={errors}
                isProductSizeDisplayable={true}
                numberOfDisplayWishlist={3}
                setNoSizeNotification={setNoSizeNotification}
                errorNotificationTimer={true}
                disableAddToBagSecondaryAction={true}
                disableAddToWishlistSecondaryAction={true}
                optimizely={optimizely}
            />
            <div className={bem('moreDetails')}>
                <a
                    className={bem('viewDetails', { loading })}
                    href={href}
                    /* istanbul ignore next */
                    onClick={() => optimizely.track('wl_recommendationsviewmoredetails')}
                >
                    {messages.product.viewMoreDetails()}
                </a>
            </div>
        </div>
    );
};

RecommendationsOptionsOverlay.propTypes = {
    product: PropTypes.object.isRequired,
    messages: PropTypes.shape({
        product: PropTypes.shape({
            viewMoreDetails: PropTypes.func.isRequired,
        }).isRequired,
    }).isRequired,
    loading: PropTypes.bool,
    optimizely: PropTypes.shape({
        track: PropTypes.func.isRequired,
    }),
    wrapperRef: PropTypes.object.isRequired,
    selectedProductVariantWithBuyableStatus: PropTypes.object.isRequired,
    selectedSize: PropTypes.object.isRequired,
    setSelectedSize: PropTypes.func.isRequired,
    noSizeNotification: PropTypes.object.isRequired,
    setNoSizeNotification: PropTypes.func.isRequired,
    CTAButtonsState: PropTypes.shape({
        addToCart: PropTypes.func,
        addToCartLoading: PropTypes.bool,
        wishlists: PropTypes.array,
        wishlistId: PropTypes.string,
        addToWishlist: PropTypes.func,
        addToWishlistLoading: PropTypes.bool,
        errors: PropTypes.object,
    }),
};

export default withOptimizely(RecommendationsOptionsOverlay);
